import {
  AUDIO_SUB_TYPES,
  BILLING_CYCLE,
  dependMeetingPlanTypeList,
  planTypes,
} from '@/common/constants';
import { getCartInfo } from "@/common/service/default-mapper"

function getDidPlanInfo(planMapJSON) {
  const {
    did_plancode,
    did_amount,
  } = planMapJSON.tollfree;

  const plans = [];

  if(did_plancode && did_amount) {
    plans.push({
      type: planTypes.TOLLFREE$DID,
      category: AUDIO_SUB_TYPES.DID,
      plan_code: did_plancode,
      amount: did_amount,
      cartInfo: getCartInfo(),
      billing_cycle: BILLING_CYCLE.MONTHLY,
      supportCoupon: true,
      dependBasePlanTypeList: dependMeetingPlanTypeList,
      typeNameKey: 'billing.tollfree.dedicated_dial_in_number.title',
    })
  }

  return plans
}

export default (planMapJSON) => {
  return getDidPlanInfo(planMapJSON)
}
